var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseComponent } from '../../utils/BaseComponent';
import { TabController } from './tabController';
import { tabEvent } from './tabEvent';
let Tab = class Tab extends BaseComponent {
    firstUpdated() {
        this.tabController = new TabController(this, this.key);
        this.requestUpdate();
    }
    render() {
        if (!this.tabController) {
            return nothing;
        }
        const active = this.tabController.activeTab === this.index;
        return html `
        <button
            data-test="tab-${this.index}"
            ?disabled=${active}
            class="items-center w-full justify-center px-16 py-4 text-ellipsis cursor-pointer
            ${this.tabController.activeTab !== this.index ? 'hover:underline text-secondary' : 'text-link'}"
            @click=${() => this.dispatchEvent(tabEvent(this.key, this.index))}
        >
       <slot></slot>
        </button>
    `;
    }
};
Tab.styles = [
    css `
      :host {
        flex-basis: 20ch;
      }
    `,
    BaseComponent.styles
];
__decorate([
    property()
], Tab.prototype, "key", void 0);
__decorate([
    property({ type: Number })
], Tab.prototype, "index", void 0);
Tab = __decorate([
    customElement('trust-tab')
], Tab);
export { Tab };
//# sourceMappingURL=tab.js.map